import { EntityType } from "../../rl-common/shared/shared/entity-type.enum";
import { ServerEntity } from "../../rl-common/shared/shared/interfaces/server-entity";
import { TagType } from "../../tags/shared/tag-type.type";
import { TagDisplay } from "../../tags/tag/tag-display";


export class Tag extends ServerEntity{ 
    tagText : string;
    tagCode : string;
    canRemove : boolean = false;
    entityType : string;
    type : TagType;
    get tagTypeFromEntity() {        
        if (this.entityType) {
            let index = this.entityType.indexOf("_");
            if (index == -1)    return 'PRIVATE';
            return this.entityType.substring(index + 1, this.entityType.length); 
        }
        return this.type;  
    };
    get tagId() {
        return this.tagTypeFromEntity + '_' + this.tagCode;
    }
 
    get entityTypeObj() {
        if (this.entityType.includes('Collection')) 
            return EntityType.COLLECTION;
        if (this.entityType.includes('Citation'))
            return EntityType.CITATION;
        if (this.entityType.includes('Section'))
            return EntityType.SECTION;
        return EntityType.LIST;
    }

    constructor(tag : TagDisplay);
    constructor(tag : Tag);
    constructor(tag : any) {
        super();
        if(tag instanceof TagDisplay) {
            this.tagText = tag.name;
            this.tagCode = tag.code;
            this.canRemove = true;
            this.type = tag.type;
        }

        else {
            Object.assign(this, tag);  
        }               
    }
}
